"use client";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Reads the preference once, at event time (a click that decides between a
 * smooth and an instant scroll). A subscribing hook would make the component
 * part of a synchronous re-render after hydration, because a server snapshot
 * has to differ from what most visitors' browsers report; the reduced-motion
 * styling itself is CSS (motion-safe, motion-reduce).
 */
export function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia(REDUCED_MOTION_QUERY).matches
  );
}
